import { queryOptions, skipToken, useMutation } from '@tanstack/react-query'
import {
  createTrigger,
  getCustomObjectFields,
  getCustomObjects,
  getTriggers,
  getViews,
  getZendeskFields,
} from './zendesk-app.api'
import { zendeskApi } from '../types'

export const zendeskQueries = {
  all: () => ['zendesk'],
  triggers: {
    all: () => [...zendeskQueries.all(), 'triggers'],
    lists: () => [...zendeskQueries.triggers.all(), 'list'],
    list: (categoryId?: string) =>
      queryOptions({
        queryKey: [...zendeskQueries.triggers.lists(), { categoryId }],
        queryFn: categoryId ? () => getTriggers(categoryId) : skipToken,
        refetchOnWindowFocus: 'always',
      }),
  },
  customObjects: {
    all: () => [...zendeskQueries.all(), 'customObjects'],
    lists: () => [...zendeskQueries.customObjects.all(), 'list'],
    list: () =>
      queryOptions({
        queryKey: [...zendeskQueries.customObjects.lists()],
        queryFn: () => getCustomObjects(),
      }),
  },
  customObjectsFields: {
    all: () => [...zendeskQueries.all(), 'customObjectsFields'],
    lists: () => [...zendeskQueries.customObjectsFields.all(), 'list'],
    list: (customObjectKey: string) =>
      queryOptions({
        queryKey: [...zendeskQueries.customObjectsFields.lists(), { customObjectKey }],
        queryFn: () => getCustomObjectFields(customObjectKey),
      }),
  },
  zendeskFields: {
    all: () => [...zendeskQueries.all(), 'zendeskFields'],
    lists: () => [...zendeskQueries.zendeskFields.all(), 'list'],
    list: () =>
      queryOptions({
        queryKey: [...zendeskQueries.zendeskFields.lists()],
        queryFn: () => getZendeskFields(),
      }),
  },
  views: {
    all: () => [...zendeskQueries.all(), 'views'],
    lists: () => [...zendeskQueries.views.all(), 'list'],
    list: () =>
      queryOptions({
        queryKey: [...zendeskQueries.views.lists()],
        queryFn: () => getViews(),
      }),
  },
}

export const useCreateTrigger = () =>
  useMutation({
    mutationFn: (trigger: Partial<zendeskApi.Trigger>) => createTrigger(trigger),
  })
